<template>
    <div class="flex flex-col gap-0 w-full">
        <slot>
            <div class="paragraph-sm text-text-secondary pt-2 px-2">
                {{ placeholder }}
            </div>
        </slot>
    </div>
</template>

<script setup lang="ts">
type Props = {
    placeholder?: string
}

withDefaults(defineProps<Props>(), {
    placeholder: 'No items available',
})
</script>
